<template>
  <v-container grid-list-md fluid pa-0 class="table-container">
    <v-layout
      row
      wrap
      class="review-row"
      v-for="assignment in assignments"
      :key="assignment.id"
    >
      <v-flex md12>
        <looking-for-reader
          :assignment="assignment"
          :book="book"
        ></looking-for-reader>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LookingForReader from "./LookingForReader";

export default {
  name: "LookingForList",
  components: { LookingForReader },
  props: ["assignments", "book"],
  data: function () {
    return {};
  },
};
</script>

<style>
.total-reviews {
  padding-top: 10px;
  color: #111;
  font-size: 18pt;
  font-weight: 500;
  text-align: center;
  font-family: "Source Sans Pro";
}

.average-rating {
  text-align: center;
}

.average-rating-details {
  font-size: 12pt;
  text-align: center;
  font-family: "Source Sans Pro";
}

.summary-row {
  padding-bottom: 30px;
}

.review-row {
  padding: 0 0 20px 0;
}
</style>

